import React from "react";
import FormAccordion from "../../../components/Form/FormAccordion";
import {
	// FileGroup,
	InputField,
	// SelectField,
	// SelectFieldStatus,
	// TextAreaField,
} from "../../../components/Form/FormComponents";
import PropTypes from "prop-types";
import { Formgroup } from "../../Products/Forms/ProductForm.styled";
import { getFormattedAmount } from "../../../utils/AmountUtils";
import { getFormattedDate } from "../../../utils/DateUtils";
function TransactionsForm({ data }) {
	return (
		<FormAccordion title='Transaction Details' open={true}>
			<div className='grid grid-cols-3 gap-3'>
				<Formgroup>
					<label>DATE / TIME</label>
					<InputField value={getFormattedDate(data?.createdAt)} />
				</Formgroup>

				<Formgroup>
					<label>TRANSACTION ID</label>
					<InputField value={`TRN-${data?.objectId?.toUpperCase()}`} />
				</Formgroup>

				<Formgroup>
					<label>APPROVAL STATUS</label>
					<InputField value={data?.approvalStatus?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>CATEGORY</label>
					<InputField value={data?.category?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>BRAND</label>
					<InputField value={data?.brand?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>MODEL</label>
					<InputField value={data?.model?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>PRICE</label>
					<InputField value={getFormattedAmount.format(data?.price)} />
				</Formgroup>

				<Formgroup>
					<label>COLOR</label>
					<InputField value={data?.color?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>CONDITION</label>
					<InputField value={data?.condition?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>DELIVERY ADDRESS</label>
					<InputField value={data?.deliveryAddress?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>DELIVERY TYPE</label>
					<InputField value={data?.deliveryType?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>DELIVERY STATUS</label>
					<InputField value={data?.delivery_status?.toUpperCase()} />
				</Formgroup>

				{/* <Formgroup>
					<label>FUNDED</label>
					<InputField value={data?.delivery_status?.toUpperCase()}  />
				</Formgroup> */}

				<Formgroup>
					<label>LEASE DURATION</label>
					<InputField value={data?.leaseDuration?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>LEASE TYPE</label>
					<InputField value={data?.leaseType?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>PAYMENT STATUS</label>
					<InputField value={data?.paymentStatus?.toUpperCase()} />
				</Formgroup>

				<Formgroup>
					<label>PAYMENT TYPE</label>
					<InputField value={data?.paymentType?.toUpperCase()} />
				</Formgroup>
			</div>
		</FormAccordion>
	);
}

TransactionsForm.propTypes = {
	data: PropTypes.object,
};

export default TransactionsForm;
